import { useState, useEffect } from "react";
import useIsMobileView from "../hooks/useIsMobileView";
import { Main, MainContent, Section, CardLayout } from '@prosolve/common-components-ui'
import SoefiaBackground from '../images/soefia-assessment/bkg-metal.png';
import PdChallengeCard from "./PdChallengeCard";
import styled from 'styled-components';
import pdChallengeData from './PdChallengeData.json'
import PdTeamSelector from "./PdTeamSelector";
import { getEnv } from '../utils'
import SurveyModal from "./SurveyModal";
import { useNavigate } from "react-router-dom";
import ProsolveLogo from '../images/prosolve-logo-new.png';
import useFetch from '../hooks/useFetch';
import moment from 'moment';
import GreenImage from '../images/team-icons/S2_ActiveTeam_Green.png';
import BlueImage from '../images/team-icons/S2_ActiveTeam_Blue.png';
import YellowImage from '../images/team-icons/S2_ActiveTeam_Yellow.png';
import PurpleImage from '../images/team-icons/S2_ActiveTeam_Purple.png';
import BlackImage from '../images/team-icons/S2_ActiveTeam_Black.png';
import RedImage from '../images/team-icons/S2_ActiveTeam_Red.png';
// import Timer from "./Timer";

const EleanorCardWrapper = styled.div`
  margin: 40px 300px 0px 300px;
`

// const Title = styled.div`
//   position: absolute;
//   top: 15px;
//   left: 25px;
//   color: #c7ffff;
//   font-size: 48px;
// `

// const Title = styled.div`
//   color: #ffffff;
//   font-size: 32px;
//   text-align: center;
//   font-weight: bold;
//   margin-bottom: 40px;
// `

// const SubTitle = styled.div`
//   color: #ffffff;
//   font-size: 24px;
//   text-align: center;
//   font-weight: bold;
//   margin: 40px 0px;
// `

export default () => {

  const urlParams = new URLSearchParams(window.location.search);
  const dateTime = urlParams.get('dateTime');

  const isMobileView = useIsMobileView();

  let pdExperienceTeamData = {};
  try {
    pdExperienceTeamData = JSON.parse(sessionStorage.getItem("pdExperienceTeamData") || '{}')
  } catch (e) {
    console.log(e)
  }

  const {
    teamColor = '',
    teamName = ''
  } = pdExperienceTeamData

  let showTeamSelector = true
  if (teamColor && teamName) {
    showTeamSelector = false;
  }

  const onTeamDataSelected = (teamColor, teamName) => {
    if (teamColor && teamName) {
      sessionStorage.setItem("pdExperienceTeamData", JSON.stringify({ teamColor, teamName }));
      // todo can improve this but good enough for now
      // window.location.reload();
    }
  }

  const [answerData, setAnswerData] = useState([])
  // const [loading, setLoading] = useState(true)

  const fetch = useFetch();

  const getAssessmentAnswerData = async () => {
    try {
      // setLoading(true)

      const today = moment(dateTime || undefined).utc().format() // moment().format('YYYY-MM-DD') // '2025-11-13'

      const assessmentNames = pdChallengeData.map(({ assessmentName}) => assessmentName).join(',')

      const response = await fetch(`assessment/pdExperienceLeaderboard?date=${today}&assessmentNames=${assessmentNames}`, { method: 'GET' })
      const jsonData = await response.json();

      const data = jsonData || {};

      if (data.error) {
        throw data.error
      }

      setAnswerData(data)
      // setLoading(false)
    } catch (e) {
      console.log(e)
      setAnswerData({})
      // setLoading(false)
    }
  }

  useEffect(() => {
    getAssessmentAnswerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const teamAnswerData = answerData.filter(({ teamName: dataTeamName, teamColor: dataTeamColor }) => dataTeamName === teamName && dataTeamColor === teamColor)

  const completionInfo = {}

  teamAnswerData.forEach(teamAnswerDataObj => {
    const { assessmentName, answers = {} } = teamAnswerDataObj;

    const answerCodeObj = answers[2] || {};

    const { answerText = '' } = answerCodeObj;

    let codeSuccessful = false;

    const codeInput = answerText.replace(/\s+/g, '').toLowerCase().trim()

    if (codeInput === 'ischool') {
      codeSuccessful = true;
    } else if (assessmentName === 'PD-Challenge1' && codeInput === 'human') {
      codeSuccessful = true;
    } else if (assessmentName === 'PD-Challenge3' && codeInput === 'driven') {
      codeSuccessful = true;
    } else if (assessmentName === 'PD-Challenge4' && codeInput === 'experiential') {
      codeSuccessful = true;
    }

    const completionInfoObj = { codeSuccessful }

    completionInfo[assessmentName] = completionInfoObj;

    // if (!completionInfo[assessmentName]) {
    //   assessmentName
    // }


  });

  // console.log(completionInfo)


  const pdChallengeCards = []
  const pdChallengeButton = []
  pdChallengeData.forEach(obj => {
    if(obj.isButton) {
      pdChallengeButton.push(obj)
    } else {
      pdChallengeCards.push(obj)
    }
  });

  // const onClickLink = (assessmentName) => {
  //   const env = getEnv()
  //   const linkUrl = `https://go.${env ? `${env}.` : ''}prosolve.com/survey?assessmentName=${assessmentName}${teamColor ? `&teamColor=${teamColor}` : ''}${teamName ? `&teamName=${teamName}` : ''}`
  //   window.open(linkUrl, '_blank')
  // }

  const getEleanorLink = (assessmentName) => {
    const env = getEnv()
    const linkUrl = `https://go.${env ? `${env}.` : ''}prosolve.com/survey?assessmentName=${assessmentName}${teamColor ? `&teamColor=${teamColor}` : ''}${teamName ? `&teamName=${teamName}` : ''}`
    return linkUrl;
  }

  // const onOpenLeaderboard = (assessmentName) => {
  //   const env = getEnv()
  //   const linkUrl = `https://go.${env ? `${env}.` : ''}prosolve.com/pdLeaderboard`
  //   window.open(linkUrl, '_blank')
  // }

  const [openSurveyObj, setOpenSurveyObj] = useState();

  const navigate = useNavigate();

  const onCloseSurvey = (event, surveyLink) => {
    setOpenSurveyObj(undefined)
    // If surveyLink from close command is the EleanorLink...auto nav to the leaderboard
    if (surveyLink === getEleanorLink(pdChallengeButton[0]?.assessmentName)) {
      navigate(`/pdLeaderboard?teamName=${teamName}`)
    } else if (Boolean(surveyLink)) {
      window.location.reload();
    }
  }

  const colorImageMap = {
    Green: GreenImage,
    Blue: BlueImage,
    Yellow: YellowImage,
    Purple: PurpleImage,
    Black: BlackImage,
    Red: RedImage
  }

  return (
    <Main $isMobileView={isMobileView} style={{
      color: '#c7ffff',
      backgroundImage: `url(${SoefiaBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      // fontFamily: '"Inter_24pt-Bold", "Open Sans", sans-serif'
    }}>
      <div style={{ position: 'absolute', top: '20px', left: '0px', display: 'flex', width: '100%', justifyContent: 'center' }}>
        <img src={ProsolveLogo} style={{ height: '40px', marginLeft: '0px', marginRight: '0px' }} alt="prosolveLogo"/>
      </div>

    {
      teamName && teamColor && colorImageMap[teamColor] &&
      <div style={{ position: 'absolute', top: '7px', right: '20px' }}>
        <img src={colorImageMap[teamColor]} style={{ height: '80px' }} alt="prosolveLogo"/>
      </div>
    }

          {
      Boolean(openSurveyObj) &&
      <SurveyModal surveyData={openSurveyObj} onClose={onCloseSurvey}/>
    }
      {/* <Timer initialTime={500} onTimeUp={() => { console.log('times up!') }} /> */}
      <MainContent $isMobileView={isMobileView} style={{ /* maxWidth: '1200px' */ maxWidth: '100%', width: '100%' }}>
        {
          showTeamSelector ?
          <PdTeamSelector 
            onTeamDataSelected={onTeamDataSelected}
          />
          :
            <Section style={{ background: 'none', fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif', marginTop: '60px' }}>
              {/* <div 
                style={{ 
                  position: 'absolute',
                  top: '10px',
                  right: '10px'
                }}
                >
                  <Button
                    style={{ color: '#ffffff', background: 'transparent' }}
                    $colored={true}
                    onClick={onOpenLeaderboard}
                  >
                    {'View Leaderboard'}
                  </Button>
              </div> */}
              {/* <Title>
                {'Select a challenge station to solve'}
              </Title> */}
              <CardLayout $maxItems={3}>
                {
                  pdChallengeCards
                    .map(pdChallengeDataObj =>
                      <PdChallengeCard
                        key={pdChallengeDataObj.name}
                        cardData={pdChallengeDataObj}
                        completionInfo={completionInfo}
                        teamColor={teamColor}
                        teamName={teamName}
                        setOpenSurveyObj={setOpenSurveyObj}
                      />)
                }
              </CardLayout>
              {/* <SubTitle>
                {'Complete this experience by clicking the button below'}
              </SubTitle> */}
              <EleanorCardWrapper>
              {
                pdChallengeButton
                  .map(pdChallengeDataObj =>
                    <PdChallengeCard
                      key={pdChallengeDataObj.name}
                      cardData={pdChallengeDataObj}
                      completionInfo={completionInfo}
                      teamColor={teamColor}
                      teamName={teamName}
                      setOpenSurveyObj={setOpenSurveyObj}
                    />
                  )
              }
              </EleanorCardWrapper>
              {/* {
                pdChallengeButton
                  .map(pdChallengeDataObj =>
                    <Button
                      key={pdChallengeDataObj.assessmentName}
                      style={{
                        display: 'inline-flex',
                        marginTop: '40px',
                        marginRight: '10px',
                        // fontWeight: 'bold',
                        fontSize: '24px',
                        width: '350px',
                        height: '40px',
                        background: 'transparent',
                        alignSelf: 'center'
                      }}
                      // onClick={() => onClickLink(pdChallengeDataObj.assessmentName)}
                      onClick={() => setOpenSurveyObj({ linkUrl: getEleanorLink(pdChallengeDataObj.assessmentName) })}
                      $colored={true}
                    >
                      {'FINISH AND SUBMIT SCORE'}
                    </Button>
                  )
              } */}
            </Section>
        }
      </MainContent>
    </Main>
  )
}